import { NextAppBaseError, } from './NextAppBaseError';
export class FatalApiError extends NextAppBaseError {
    static className = 'FatalApiError';
    status;
    constructor(props) {
        super(props);
        this.status = props.status;
    }
    convertToJSON(debug) {
        const props = {
            ...super.convertToJSON(debug),
            status: this.status,
        };
        return props;
    }
    assignJSON(json) {
        if (!super.assignJSON(json))
            return false;
        this.status = json.status;
        return true;
    }
}
